module.exports = __webpack_public_path__ + "img/maximize.96fe7011.svg";